<template>
  <svg
    :fill="fillColor"
    id="wave-one"
    viewBox="0 0 1440 146"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1439.98 70.3892C1320.66 64.6381 1211.01 40.0638 1059.86 41.6735C811.943 44.3136 572.91 137.321 329.239 145.228H265.059C177.655 142.242 89.5083 126.425 0.000488281 89.7695V0H1439.98V70.3892Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    fillColor: String
  }
};
</script>

<style></style>
